"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SfuTransceiverController = void 0;
class SfuTransceiverController {
    constructor(transceiver, type, logger) {
        this.start = () => {
            var _a, _b;
            const sender = this.transceiver.sender;
            const parameters = sender.getParameters();
            this.logger.debug('spsc-start', this.type, parameters);
            if (((_a = sender.track) === null || _a === void 0 ? void 0 : _a.kind) !== 'video' || parameters.encodings.length <= 1) {
                return;
            }
            const settings = (_b = sender.track) === null || _b === void 0 ? void 0 : _b.getSettings();
            // drop simulcast
            if (Math.min(settings === null || settings === void 0 ? void 0 : settings.height, settings === null || settings === void 0 ? void 0 : settings.width) < 540) {
                for (let i = 1; i < parameters.encodings.length; i++) {
                    parameters.encodings[i].active = false;
                }
                sender.setParameters(parameters);
                this.logger.debug('spsc-drop-simulcast', settings);
            }
            this.interval = setInterval(this.adjust, 3000);
        };
        this.stop = () => {
            this.logger.debug('spsc-stop', this.type);
            clearInterval(this.interval);
        };
        this.adjust = () => __awaiter(this, void 0, void 0, function* () {
            const sender = this.transceiver.sender;
            const parameters = sender.getParameters();
            let stat;
            (yield sender.getStats()).forEach((s) => {
                if (s.type === 'outbound-rtp' && s.rid === 'h') {
                    stat = s;
                }
            });
            if (!stat)
                return;
            // drop simulcast
            if ((Math.min(stat.frameHeight, stat.frameWidth) < 540 || stat.qualityLimitationReason === 'cpu') &&
                parameters.encodings.find((e, i) => i > 0 && e.active)) {
                for (let i = 1; i < parameters.encodings.length; i++) {
                    parameters.encodings[i].active = false;
                }
                sender.setParameters(parameters);
                clearInterval(this.interval);
                this.logger.debug('spsc-drop-simulcast', stat);
                return;
            }
        });
        this.transceiver = transceiver;
        this.type = type;
        this.logger = logger || console;
        this.start();
    }
}
exports.SfuTransceiverController = SfuTransceiverController;
//# sourceMappingURL=TransceiverController.js.map